import React, { Component } from 'react';
import { Row } from "reactstrap";

// Modal Video 
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

import Tutorial from './tutorial'

class Tutorials extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            tutorials: props.tutorials
        }
        this.openModal = this.openModal.bind(this);
    }

    openModal() {
        this.setState({ isOpen: true })
    }

    render() {
        return (
            <React.Fragment>
                    <Row>
                        {
                            this.state.tutorials.map((tutorial, index) =>(
                                <Tutorial key={index} videoId={tutorial.videoId} thumbnail={tutorial.thumbnail}></Tutorial>                       
                            ))
                        }
                    </Row>
                    <Row>
                        <p style={{color: "#FFFFFF", fontSize: "0.5px"}}>
                        telegramtradecopier.com, telegramtradecopier, telegram trade copier, telegramtrade copier, telegram tradecopier,
                        telegramfxcopier, telegram traders, telegram forex copier review, telegram to mt4, telegram trading signals, 
                        orex peace army change user name, copy trading signal, telegram trading channels, forexpeacearmy,
                        free demo, lifetime licenece, standalone, online money, telegram to mt4 copier account, trade copier,
                        trading copier, trade copier, open multiple tps ea, jamie tradesfx review, copy trading signal, trade copier mt4,
                        proforextrades, good telegram signal services, metatrader, MT4, signal review, telegram channels
                        telegram, MT4, mt4, forex, trade, signal, money, internet, how, to
                        </p>
                    </Row>
            </React.Fragment>
        );
    }
}

export default Tutorials;